export default (path) => `${import.meta.env.VITE_APP_URL}/dashboard/images/${path}`;